import PropTypes from 'prop-types';
import React from 'react';
import ShapedButton from './ShapedButton';
import SvgIcon from './SvgIcon';
import SvgShadow from './SvgShadow';

const enabledStyle = (isEnabled) => (isEnabled ? '' : ' disabled-button');

const highlightedStyle = (isHighlighted) => (isHighlighted ? ' pulse' : '');

const TriangleButton = (props) => {
    const style = `triangle-button${enabledStyle(props.isEnabled)}${highlightedStyle(props.isHighlighted)}`;
    return (
        <ShapedButton
            styles={style}
            onClick={props.onClick}
            isEnabled={props.isEnabled}>
            <SvgShadow ariaLabelledBy="Triangle button shadow" ariaDescribedBy="Triangle button shadow" type="triangle-button" id="triangle-button-shadow" />
            <SvgIcon ariaLabelledBy="Triangle button" ariaDescribedBy="Triangle button" class="svg-triangle-button lantern-svg" id="triangle-button" />
        </ShapedButton>
    );
};

TriangleButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    isEnabled: PropTypes.bool,
    isHighlighted: PropTypes.bool,
};

TriangleButton.defaultProps = {
    isEnabled: true,
    isHighlighted: false,
};

export default TriangleButton;
